import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { MediaAds } from "../../types/campaigns";
import { useStyles } from "./styles";
import { memo } from "react"

type TCardImage = {
  image: string;
  media_ads: MediaAds[];
  title: string;
  date: string;
  type: string;
  handleClick?: () => void;
};

function CardImageComponent({
  image,
  media_ads,
  title,
  date,
  type,
  handleClick,
}: TCardImage) {
  const styles = useStyles();

  const translateType = useMemo(() => {
    switch (type.toUpperCase()) {
      case "WHATSAPP":
        return "WhatsApp";
      case "FACEBOOK":
        return "Facebook";
      case "INSTAGRAM":
        return "Instagram";
      case "SMS":
        return "SMS";
      case "SMS_V2":
        return "SMS";
      case "WHATSAPP_GROUP":
        return "Whatsapp Grupo";
      case "INSTAGRAM_CAROUSEL":
        return "Instagram Carrossel";
      case "ADS":
        return "Impulsionada";
    }
  }, [type]);

  const imageIcon = useMemo(() => {
    switch (type.toUpperCase()) {
      case "INSTAGRAM":
      case "INSTAGRAM_CAROUSEL":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/Instagram+1.jpg";
      case "FACEBOOK":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/Facebook+-+Original.png";
      case "WHATSAPP":
      case "WHATSAPP_GROUP":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/whatsapp+1.png";
      case "SMS":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/smsV2.png";
      case "SMS_V2":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/smsV2.png";
      case "ADS":
        return "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/turbinada.png";
    }
  }, [type]);

  const previewImageAds = useMemo(() => {
    if (media_ads && media_ads.length) {
      return media_ads.find(
        (media) => media.preview_url !== null && media.preview_url !== undefined
      )?.preview_url;
    }
    return false;
  }, [media_ads]);

  let imageLocal;

  switch (type.toUpperCase()) {
    case "SMS":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/SMS-V4.webp");
      break;
    case "SMS_V2":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/SMS-V4.webp");
      break;
    case "INSTAGRAM_CAROUSEL":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/carrossel.png");
      break;
    case "INSTAGRAM":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/instagram-logo-512-512.png");
      break;
    case "FACEBOOK":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/facebook-logo-512-512.png");
      break;
    case "WHATSAPP":
    case "WHATSAPP_GROUP":
      image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/whatsapp-logo-512-512.png");
      break;
    case "ADS":
      previewImageAds
        ? (imageLocal = previewImageAds)
        : image
        ? (imageLocal = image)
        : (imageLocal =
            "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/facebook_ads.jpg");
      break;
    default:
      imageLocal = image;
      break;
  }

  return (
    <Stack
      className={styles.card}
      spacing={2}
      direction="row"
      alignItems="center"
      onClick={() => (handleClick ? handleClick() : null)}
    >
      <img
        className={styles.root}
        src={
          imageLocal?.includes("mp4")
            ? "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/video.png"
            : imageLocal ||
              "https://datasalesio-imagens.s3.amazonaws.com/tmp-jhgs/icons/message-whats.png"
        }
        alt="name-src"
      />
      <Stack spacing={1}>
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 250,
          }}
        >
          {title || "Propaganda 1"}
        </Typography>
        <Typography variant="subtitle2" fontWeight={400} color="GrayText">
          🗓️ {date}
        </Typography>
        <Typography
          variant="subtitle2"
          fontWeight={400}
          color="GrayText"
          display={"flex"}
          alignItems={"center"}
        >
          <img
            src={imageIcon}
            alt={translateType}
            className={styles.iconTypeCampaign}
          />
          {translateType}
        </Typography>
      </Stack>
    </Stack>
  );
}


export const CardImage = memo(CardImageComponent);